import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { BaseUpdateComponent } from '@app/shared/components/base/base-update.component';
import {
    ClaimNetChannelEnum,
    RecipientOptions,
    RecipientOptionsSubChannels
} from '@app/shared/models/recipient-options';
import { RecipientOptionsService, RecipientOptionsUriBuilderParams } from '@app/core/services/recipient-options.service';
import { TranslationEntry } from '@app/shared/models/translatable';

@Component({
    selector: 'recipient-options',
    templateUrl: './recipient-options.component.html',
    styleUrls: ['./recipient-options.component.scss']
})
export class RecipientOptionsComponent extends BaseUpdateComponent<RecipientOptions, RecipientOptionsUriBuilderParams>
                                       implements OnInit {

    @Input()
    public channels: TranslationEntry[];

    @Output()
    public canceled = new EventEmitter();

    protected paramsIdNames = [];

    public subChannels: TranslationEntry[];

    protected _selectedChannel: TranslationEntry;

    get selectedChannel() {
        return this._selectedChannel;
    }

    set selectedChannel(channel: TranslationEntry) {
        if (this._selectedChannel &&
            this._selectedChannel.key === ClaimNetChannelEnum.MY_CLAIM &&
            (!channel || channel.key !== ClaimNetChannelEnum.MY_CLAIM)) {
            this.selectedSubChannel = null;
        }

        this._selectedChannel = channel;
        this.recipientOptions.setChannel(this._selectedChannel);
    }

    protected _selectedSubChannel: TranslationEntry;

    get recipientOptions() {
        return this.updated;
    }

    get selectedSubChannel() {
        return this._selectedSubChannel;
    }

    set selectedSubChannel(subChannel: TranslationEntry) {
        this._selectedSubChannel = subChannel;
        this.recipientOptions.setSubChannel(this._selectedSubChannel);
    }

    constructor(protected componentServiceBundle: ComponentServiceBundle,
                protected recipientOptionsService: RecipientOptionsService) {
        super(componentServiceBundle, recipientOptionsService);
        this._idPrefix = 'recipient-options.';
    }

    public ngOnInit() {
        super.ngOnInit();

        this.subChannels = RecipientOptionsSubChannels.ALL;

        if (this.recipientOptions.channel) {
            this._selectedChannel = this.channels.find(channel => channel.key === this.recipientOptions.channel);
        }

        if (this.recipientOptions.sub_channel) {
            this._selectedSubChannel = this.subChannels.find(channel => channel.key === this.recipientOptions.sub_channel);
        }
    }

    public cancel(): void {
        this.canceled.emit();
    }

    public submit(): void {
        if (!this.recipientOptions.id) {
            this.recipientOptionsService.create(this.generateUriBuilderParams(), this.recipientOptions)
                                        .subscribe(result => {
                this.afterChange(result);
            });
        } else {
            this.update();
        }
    }

    protected generateUriBuilderParams(): RecipientOptionsUriBuilderParams {
        return new RecipientOptionsUriBuilderParams(this.original);
    }

}
